import * as React from 'react'
import { participantsFormDataActions } from '@/scopes/checkout/domain/actions/participantsFormData'
import { preferencesDataActions } from '@/scopes/checkout/domain/actions/preferencesFormData'

interface CheckoutPersonalDetailsDependencies {
  actions?: ReturnType<typeof participantsFormDataActions>
  preferenceActions?: ReturnType<typeof preferencesDataActions>
}

const defaultDependencies: CheckoutPersonalDetailsDependencies = {}

const CheckoutPersonalDetailDependenciesContext = React.createContext<CheckoutPersonalDetailsDependencies>(defaultDependencies)

export function CheckoutPersonalDetailsDependenciesProvider({
  children,
  dependencies = defaultDependencies,
}: React.PropsWithChildren<{ dependencies?: CheckoutPersonalDetailsDependencies }>) {
  return (
    <CheckoutPersonalDetailDependenciesContext value={dependencies}>
      {children}
    </CheckoutPersonalDetailDependenciesContext>
  )
}

export function useCheckoutPersonalDetailsDependencies() {
  return React.use(CheckoutPersonalDetailDependenciesContext)
}

export function useCheckoutPersonalDetailsActions() {
  const { actions } = useCheckoutPersonalDetailsDependencies()
  if (!actions) {
    throw new Error('actions not provided')
  }
  return actions
}
